import { OptionAvailability } from '../../model/industry';
import { StoreRolesService, ST_Roles } from './store-role.service';
import { OptionInfo } from 'src/app/model/feature';
import { AdministrativeInfo } from '../../model/AdministrativeInfo';
import { MiGenParameters } from '../../model/MiGenParameters';
import { ServiceUtilsService } from 'src/app/core/services/service-utils.service';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { AlertDialogComponent } from '../../store/dialogs/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { RoleNames, RolesWeight } from 'src/app/authentication/auth-helpers';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { CouponService } from './coupon.service';
import { Feature } from '../../model/feature';
import { FunctionalityGroup, ItemsAdministrativeInfo } from '../../model/configuration';
import { IndustryPurchasedInfo } from 'src/app/model/industry';
import 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { OperationResult, TbAuthService } from '@tb/auth';
import { ConfigurationService } from './configuration.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { IndustryDescription } from 'src/app/model/industry';
import { CmsService } from './cms.service';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GenericContactForLogin, TrainingContact } from 'src/app/model/customer';
import { UrlMaker } from '../../commons/url-maker';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ContactService {


    constructor(
      private http: HttpClient
    ) {}

    async ngOnInit() {}


    public async sendmailcontactforlogin(tempContact: GenericContactForLogin, authToken: string): Promise<OperationResult> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('sendContactGenericLoginMail').toString();

        const jobj = {
            authenticationToken: authToken,
            contactData: tempContact,
        };
        return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
    }


    public async sendmailcontactfortraining(tempContact: TrainingContact, authToken: string): Promise<OperationResult> {

      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('sendRequestForTraining').toString();
      //TODO implementare invio mail
      const jobj = {
          authenticationToken: authToken,
          contactData: tempContact,
      };
      return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
  }
}


